import { render } from "./OidoModal.vue?vue&type=template&id=42b7d3b6&scoped=true"
import script from "./OidoModal.vue?vue&type=script&lang=js"
export * from "./OidoModal.vue?vue&type=script&lang=js"

import "./OidoModal.vue?vue&type=style&index=0&id=42b7d3b6&scoped=true&lang=css"
import "./OidoModal.vue?vue&type=style&index=1&id=42b7d3b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b7d3b6"]])

export default __exports__